const PROJECT_SUMMARY_PROMPT = 'Summarize this project using current AES application data and relevant indexed documents. Clearly separate live application data from document-derived information, and identify any conflicts without reconciling them automatically.';

const STARTER_ACTIONS = [
  {
    label: 'Find project details',
    prompt: '@',
    opensProjectPicker: true,
  },
  {
    label: 'Summarize Project',
    prompt: `${PROJECT_SUMMARY_PROMPT} @`,
    opensProjectPicker: true,
  },
];

export { PROJECT_SUMMARY_PROMPT, STARTER_ACTIONS };
